import ProfitMeasureField from './ProfitMeasureField.component';

export default ProfitMeasureField;
